<template lang="html">
	<div 
		class="rs-modal" 
		v-show="show">
		<div 
			class="rs-modal-backdrop" 
			@click="hide"/>
		<div class="rs-modal-content">
			<slot/>
		</div>
		<div class="rs-modal-close">
			<button class="rs-modal-close-button">
				<x-icon 
					class="icon" 
					@click="hide"/>
			</button>
		</div>
	</div>
</template>

<script>
import { XIcon } from 'vue-feather-icons'

export default {
	name: 'Modal',
	props: {
		show: Boolean
	},
	components: {
		XIcon
	},
	methods: {
		hide() {
			this.$emit('hide')
			this.$emit('update:show', false)
		}
	}
}
</script>

<style lang="css" scoped>
.rs-modal-backdrop{
	position: absolute;
	z-index: 1000;
	top:0;
	right: 0;
	left:0;
	bottom: 0;
	background-color: rgba(0,0,0,0.8);
}
.rs-modal-content{
	width: 90%;
	z-index: 3000;
}
.rs-modal{
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	z-index: 3000;
	top:0;
	right: 0;
	left:0;
	bottom: 0;
}
.rs-modal-close{
	position: absolute;
	z-index: 2000;
	top:0;
	right:0;
}
.rs-modal-close-button{
	background-color: transparent;
	outline:none;
	border:none;
}
.rs-modal-close .icon{
	color: #fff;
	margin: 20px;
	opacity: 0.7;
	cursor: pointer;
	width: 50px;
	height:50px;
}
.rs-modal-close .icon:hover{
	opacity: 1;
}
</style>
